import { FCEVENT } from "./fc";
import { Fcgrand } from "./fcgrand";
import {
  ObjStatus,
  CacheService,
  ParentBusiness,
  SystemBusiness
} from "fccore2";
import { FceditBusiness } from "./business/fcedit.business";
import { GetMainObjWay } from "./grand.component";
export abstract class Fcdetail extends Fcgrand {
  /**
   * æ ¹æ®äº§åidåæ¨¡åid
   * @param pid äº§åid
   * @param aid æ¨¡åid
   *
   */
  constructor(stateName: string, EVENT: any, mId?: string, aId?: string) {
     /** ç¶ç±»çåå§å */
     super(stateName, EVENT, mId, aId);
    /**  å½æidåæ°ä¼ æ¡ä»¶è¿æ¥çæ¶åå¤çè¿ç¨ */
  }
  /**
   * åå§åæ°æ®å¯¹è±¡
   */
  initChildData(): any {
    return {
      /** é»è®¤éä¸­çç´¢å¼ */
      selectedIndex: 0,
      /** æ¯å¦æä¸ä¸æ¡ */
      hasNext: false,
      /** æ¯å¦æä¸ä¸æ¡ */
      hasPrev: false,
      // ä¸»æ°æ®åå®¹
      mainObj: {},
      /** ç¼å­å¯¹è±¡åå®¹ï¼ä¸»è¦æ¯å¨ä¸ä¸æ¡ä¸ä¸æ¡ä½¿ç¨ */
      mainObjs: CacheService.getS(this.appId + "DATA") || [],
      /** å½åä¸»å¯¹è±¡è·åæ¹å¼ */
      getMainObjWay: GetMainObjWay.cache,
      /** å½åå¯¹è±¡ç¶æ */
      objStatus: ObjStatus.ADDED
      /**  é¡µé¢éç½®çæææ ¡éªå­æ®µçå¯¹è±¡ */
    };
  }
  /**
   * å­ç±»æ°æ®åå§å
   */
  abstract initData(): any;
  /**
   * å­ç±»åå§åä¼ å¼
   */
  abstract init(): any;
  /**
   * åå§åå½åå¯¹è±¡åå®¹
   */
  ngOnInit() {
    /** æ§è¡æ¥è¯¢äºä»¶ */
    this.init();
  }
  /**
   * å­ç±»åå§åå¯¹è±¡
   */
  addNew(mainObj: any): boolean {
    return true;
  }
  /**
   * èªå®ä¹äºä»¶åç§°ï¼ææèªå®ä¹äºä»¶çå¥å£
   * @param eventName äºä»¶åç§°
   * @param param åæ°
   * overload
   */
  public event(eventName: string, param?: any): void {
    if (this.EVENT[eventName]) {
      SystemBusiness.store.dispatch(this.EVENT[eventName].func(param));
    } else if (this[eventName]) {
      this[eventName](param);
    }
    this.fcEvent.emit({
      eventName,
      param
    });
  }
  /**
   * ä¿å­ä¹åçæä½
   */
  beforeSave(): boolean {
    return true;
  }
  /**
   * ä¿å­ä¹åçæä½
   */
  afterSave(): void {}
  /**
   * æ ¡éªæ¯å¦å­å¨ä¸ä¸æ¡ä¸ä¸æ¡
   */
  checkHasOne(): void {
    if (this.data.mainObjs[this.data.selectedIndex + 1]) {
      this.data.hasNext = true;
    }
    if (this.data.mainObjs[this.data.selectedIndex - 1]) {
      this.data.hasPrev = true;
    }
  }
  /**
   * ä¸ä¸æ¡
   * @param action æä½
   */
  prev(): void {
    if (this.data.selectedIndex !== -1) {
      if (this.data.mainObjs && this.data.mainObjs.length > 0) {
        this.data.selectedIndex--;
        this.checkHasOne();
        this.data.mainObj = this.data.mainObjs[this.data.selectedIndex];
      }
    }
  }
  /**
   * ä¸ä¸æ¡
   * @param action äºä»¶
   */
  next(): void {
    if (this.data.selectedIndex !== -1) {
      if (this.data.mainObjs && this.data.mainObjs.length > 0) {
        this.data.selectedIndex++;
        this.data.mainObj = this.data.mainObjs[this.data.selectedIndex];
        this.checkHasOne();
      }
    }
  }

  /**
   * ä¿å­æ°å»º
   * @param action æä½
   */
  saveNew(action: string): void {
    FceditBusiness.saveNew(
      this.data.mainApp,
      this.data.mainObj,
      this.data.mainValid,
      this.data.mainFormFields,
      this.beforeSave,
      this.afterSave,
      this
    );
  }
  /**
   * ä¿å­å¤å¶
   * @param action æä½
   */
  cardSaveCopy(action: string): void {
    FceditBusiness.cardSaveCopy(
      this.data.mainApp,
      this.data.mainObj,
      this.data.mainValid,
      this.data.mainFormFields,
      this.beforeSave,
      this.afterSave,
      this
    );
  }
  /**
   * ä¿å­
   * @param action äºä»¶åç§°
   */
  cardSave(action: string): void {
    FceditBusiness.cardSave(
      this.data.mainApp,
      this.data.mainObj,
      this.data.mainValid,
      this.data.mainFormFields,
      this.beforeSave,
      this.afterSave,
      this
    );
  }
  /**
   * ä¿å­è¿å
   * @param action äºä»¶åç§°
   */
  cardSaveBack(action: string): void {
    FceditBusiness.cardSaveBack(
      this.data.mainApp,
      this.data.mainObj,
      this.data.mainValid,
      this.data.mainFormFields,
      this.beforeSave,
      this.afterSave,
      this.cardBack,
      this
    );
  }

  /**
   * è¡¨åè¿å
   * @param action äºä»¶åç§°
   */
  cardBack(action?: string): void {}

  /**
   * è¡¨åå·¥å·æ äºä»¶
   * @param event äºä»¶
   */
  tlbformEvent(event: FCEVENT): void {
    this.adformEvent(event);
  }

  /**
   * æ ¹æ®è¡¨åå¤çäºä»¶
   * @param action äºä»¶åç§°
   */
  adformEvent(event: FCEVENT): void {
    switch (event.eventName) {
      case "cardSave":
        this.cardSave(event.eventName);
        break;
      case "cardAdd":
        this.addNew(this.data.mainObj);
        break;
      case "cardSaveNew":
        this.saveNew(event.eventName);
        break;
      case "cardSaveBack":
        this.cardSaveBack(event.eventName);
        break;
      case "cardSaveCopy":
        this.cardSaveCopy(event.eventName);
        break;
      case "cardBack":
        this.cardBack(event.eventName);
        break;
      default:
        this.event(event.eventName, event);
    }
  }
}
